import { AutoMap } from "@automapper/classes";
import { AreaMapDTO } from "./area-map.dto";
import { GlobalTaskDTO } from "./global-task.dto";
import { MeanOfPreventionDTO } from "./mean-of-prevention.dto";
import { ProcessCalculationDTO } from "./process-calculation.dto";
import { ProcessMeasureDTO } from "./process-measure.dto";
import { ProcessTechniqueDTO } from "./process-technique.dto";



export class ProcessDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    name!: string;
    @AutoMap()
    customerReference?: string;
    @AutoMap()
    type!: number;
    @AutoMap()
    dustLevel!: string;
    @AutoMap()
    dustLoadType!: string;
    @AutoMap()
    subSection!: number;
    @AutoMap()
    observation?: string;
    @AutoMap()
    ventilationGlobale!: number;
    @AutoMap()
    volumeRenouvellementAir?: number;

    @AutoMap()
    processMesure: ProcessMeasureDTO = new ProcessMeasureDTO();
    @AutoMap(() => [ProcessTechniqueDTO])
    processTechniqueList: ProcessTechniqueDTO[] = [];
    @AutoMap(() => [GlobalTaskDTO])
    taskList: GlobalTaskDTO[] = [];
    @AutoMap()
    processCalculation!: ProcessCalculationDTO;
    @AutoMap(() => [MeanOfPreventionDTO])
    envCollectiveMeansOfPreventionList: MeanOfPreventionDTO[] = [];
    @AutoMap()
    areaMap!: AreaMapDTO;
}
